import React, { Component } from "react";

class AgorasPrice extends Component {
  render() {
    return (
      <div className="col-lg-4 p-3 col-md-6 home-market-stat-col">
        <div
          className="market-column h-100 p-3"
          style={{
            background: "var(--cardBg)",
            border: "var(--card-border)",
            transition: "color 0.2s ease-out, background 0.2s ease-out"
          }}
        >
          <div className="market-inner-col d-flex justify-content-between mb-3">
            <span className="badge badge-warning market-bedge">
              AGORAS PRICE
            </span>
            <img
              className="img-fluid"
              src={require("../../../assets/icons/share-icon.svg")}
              alt="share"
            />
          </div>
          <h3
            className="market-col-heading text-left"
            style={{
              color: "var(--h3Color)",
              transition: "color 0.2s ease-out, background 0.2s ease-out"
            }}
          >
            <span className="first-text">Agoras</span>
            <span className="agoras-icon">
              <img
                className="img-fluid pl-2 pr-2"
                src={require("../../../assets/icons/agoras-icon.svg")}
                alt="Agoras"
              />
            </span>
            <span className="market-agrs"> AGRS</span>
          </h3>
          <p
            className="market-top-para mt-2"
            style={{
              color: "var(--pDescColor)",
              transition: "color 0.2s ease-out, background 0.2s ease-out"
            }}
          >
            Fully featured itellegent economy
          </p>

          <div className="market-inner-col d-flex justify-content-between sector-category">
            <span
              className="currency-row"
              style={{
                color: "var(--pDescColor)",
                transition: "color 0.2s ease-out, background 0.2s ease-out"
              }}
            >
              Sector : <span className="currency-text">Currency</span>
            </span>
            <span
              className="currency-row"
              style={{
                color: "var(--pDescColor)",
                transition: "color 0.2s ease-out, background 0.2s ease-out"
              }}
            >
              Category : <span className="currency-text">Currency</span>
            </span>
          </div>

          <div className="price-div mt-4 text-left">
            <h2
              className="figure "
              style={{
                color: "var(--h2Color)",
                transition: "color 0.2s ease-out, background 0.2s ease-out"
              }}
            >
              {" "}
              $8,352.03 <span className="discount-figure">(+0.03%)</span>
            </h2>
            <p className="real-update">0.00002308 BTC +2.6%</p>

            <p
              className="main-para-market mt-4"
              style={{
                color: "var(--pColor)",
                transition: "color 0.2s ease-out, background 0.2s ease-out"
              }}
            >
              Agoras is the first coin of natural and artificial knowledge. It
              represents all tradable knowledge and computational resources on
              the Tau network, whilst acting as the first monetary market to
              acquire{" "}
              <span style={{ color: "var(--a)" }}>
                <u>risk-free interest</u>
              </span>{" "}
              without printing new money.
            </p>
            <div className="text-center my-3">
              <button
                className="btn btn-primary btn-lg btn-block agoras-buy-btn"
                type="button"
                style={{
                  background: "var(--btnColor)",
                  transition: "color 0.2s ease-out, background 0.2s ease-out"
                }}
              >
                Buy Agoras
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AgorasPrice;
